import AddFullScreenViewContainer from './containers/AddFullScreenViewContainer'

export default AddFullScreenViewContainer
